import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const enemyEntries: RawTilesetEntry[] = [
	{
		key: "Squid",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "Squid_0.png", interval: 250 },
					{ filename: "Squid_1.png", interval: 250 },
				],
			},
		],
	},
	{
		key: "AlbinoSquid",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "AlbinoSquid_0.png", interval: 250 },
					{ filename: "AlbinoSquid_1.png", interval: 250 },
				],
			},
		],
	},
	{
		key: "Horned",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "HornedMob_0.png", interval: 250 },
					{ filename: "HornedMob_1.png", interval: 250 },
				],
			},
		],
	},
	{
		key: "Slugant",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "Slugant_0.png", interval: 250 },
					{ filename: "Slugant_1.png", interval: 250 },
				],
			},
		],
	},
	{
		key: "ToxicSlug",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				frames: [
					{ filename: "RedSlug_0.png", interval: 250 },
					{ filename: "RedSlug_1.png", interval: 250 },
				],
			},
		],
	},
	{
		key: "Biter",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				tags: { normal: true },
				frames: [
					{ filename: "BiterB_1.png", interval: 250 },
					{ filename: "BiterB_2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["E"],
				tags: { hurt: true },
				frames: [
					{ filename: "BiterB_0.png", interval: 250 },
					{ filename: "BiterB_1.png", interval: 250 },
				],
			},
		],
	},
	{
		key: "Amoeba",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "Amoeba.png", interval: 300 },
					{ filename: "Amoeba2.png", interval: 300 },
				],
			},
		],
	},
	{
		key: "ArrowMob",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [{ filename: "ArrowMob_E.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "ArrowMob_NE.png", interval: 0 }],
			},
		],
	},
	{
		key: "Robot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				tags: { wandering: true },
				pointsTo: ["W"],
				frames: [{ filename: "Robot5.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { off: true },
				pointsTo: ["W"],
				frames: [{ filename: "Robot5_Off.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { engaging: true },
				pointsTo: ["W"],
				frames: [{ filename: "Robot5.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { attacking: true },
				pointsTo: ["W"],
				frames: [
					{ filename: "Robot5_S1.png", interval: 100 },
					{ filename: "Robot5_S2.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "PlowRobot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				tags: { wandering: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot2b.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { off: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot2c.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { engaging: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot2.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { attacking: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [
					{ filename: "PlowRobot2b.png", interval: 100 },
					{ filename: "PlowRobot2.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "BossPlowRobot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				tags: { off: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot3_off.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { wandering: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot3.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { engaging: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot3.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { attacking: true },
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "PlowRobot3.png", interval: 0 }],
			},
		],
	},
	{
		key: "CaveRobot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				tags: { wandering: true },
				pointsTo: ["W"],
				frames: [{ filename: "CaveRobot.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { off: true },
				pointsTo: ["W"],
				frames: [{ filename: "CaveRobot_Off.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { engaging: true },
				pointsTo: ["W"],
				frames: [{ filename: "CaveRobot.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { attacking: true },
				pointsTo: ["W"],
				frames: [
					{ filename: "CaveRobot_S1.png", interval: 100 },
					{ filename: "CaveRobot_S2.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "FloatingRobot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				tags: { off: true },
				pointsTo: ["W"],
				frames: [{ filename: "Robot7_Off.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { flying: true },
				pointsTo: ["W"],
				frames: [
					{ filename: "Robot7b_0.png", interval: 125 },
					{ filename: "Robot7b_1.png", interval: 125 },
					{ filename: "Robot7b_2.png", interval: 125 },
					{ filename: "Robot7b_3.png", interval: 125 },
				],
			},
		],
	},
	{
		key: "EngineerRobot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				tags: { normal: true },
				pointsTo: ["W"],
				frames: [{ filename: "Engineer_0.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { repairing: true },
				pointsTo: ["W"],
				frames: [
					{ filename: "Engineer_1.png", interval: 125 },
					{ filename: "Engineer_2.png", interval: 125 },
				],
			},
		],
	},
	{
		key: "HeavyRobot",
		allowTransform: true,
		animations: [
			{
				height: 3,
				width: 3,
				loop: true,
				pointsTo: ["E"],
				frames: [{ filename: "HeavyRobot.png", interval: 0 }],
			},
		],
	},
	{
		key: "BlackHoleRobot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				height: 1.4,
				width: 1.4,
				offsetX: -0.2,
				frames: [{ filename: "HeavyRobot.png", interval: 0 }],
			},
		],
	},
	{
		key: "RangedMobTest",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				frames: [{ filename: "Robot_gun.png", interval: 0 }],
			},
		],
	},
	{
		key: "MiningRobot",
		allowTransform: true,
		animations: [
			{
				pointsTo: ["W"],
				height: 2,
				width: 2,
				loop: true,
				frames: [{ filename: "Driller2.png", interval: 0 }],
			},
		],
	},
	{
		key: "ArtilleryRobot",
		allowTransform: true,
		animations: [
			{
				pointsTo: ["W"],
				height: 2,
				width: 2,
				loop: true,
				frames: [{ filename: "ArtilleryRobot.png", interval: 0 }],
			},
		],
	},
	{
		key: "RockMobCave",
		sprite: "RockCave.png",
	},
	{
		key: "DummyMob",
		sprite: "DummyMob.png",
	},
	{
		key: "DummyMobB",
		sprite: "DummyMobB.png",
	},
];
